<template>
  <v-row>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card>
        <v-card-title>
          Reports list
        </v-card-title>
        <v-card-text>Reports from EUREC<sup>4</sup>A campaign </v-card-text>
        <v-container fluid>
          <v-row justify="left">
            <div style="margin-left:20px">
              <v-icon>mdi-newspaper-variant-outline</v-icon>&nbsp;Report from RV
              Ronald H. Brown - 8 January 2020:&nbsp;
              <strong
                ><a
                  href="https://observations.ipsl.fr/aeris/eurec4a-data/REPORTS/RV-RONALDHBROWN/2020/20200108/Brown-0108.pdf"
                  target="_blank"
                  >Brown-0108.pdf</a
                ></strong
              >
            </div>
          </v-row>
          <v-row justify="left">
            <div style="margin-left:20px">
              <v-icon>mdi-newspaper-variant-outline</v-icon>&nbsp;Report from RV
              Ronald H. Brown - 7 January 2020:&nbsp;
              <strong
                ><a
                  href="https://observations.ipsl.fr/aeris/eurec4a-data/REPORTS/RV-RONALDHBROWN/2020/20200107/Brown-0107.pdf"
                  target="_blank"
                  >Brown-0107.pdf</a
                ></strong
              >
            </div>
          </v-row>
          <br /><br />
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({})
};
</script>
